import { useNavigate } from 'react-router-dom'
import setcLogo from '../assets/images/craig_setcLogo.png'
import { useTheme } from '../ThemeContext'
import { company } from '../data/AffiliateData'

export default function LeftSideBar({ activeTab, setActiveTab, leftSideBarOpen, setLeftSideBarOpen }) {
  const sidebarClass = leftSideBarOpen ? 'translate-x-0' : '-translate-x-full'
  const navigate = useNavigate()
  const { isDarkMode } = useTheme()

  const handleTabClick = (tab, path, filterLeadStages = null) => {
    setActiveTab(tab)
    navigate(path);
    setLeftSideBarOpen(false)
  }

  return (
    <div className={`fixed top-0 left-0 w-72 h-full bg-white shadow-lg transform ${sidebarClass} transition-transform duration-300 p-6 z-10 overflow-auto ${isDarkMode && 'bg-gray-800'}`}>
      <div className="flex justify-between items-center mb-8">
        <img onClick={() => handleTabClick('dashboard', '/affiliate/dashboard')} src={company.companyLogoURL} className='w-32 cursor-pointer' />
        <button onClick={() => setLeftSideBarOpen(false)} className='text-red-700 hover:text-red-900 transition-colors duration-200'>
          <svg xmlns='http://www.w3.org/2000/svg' className='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12' />
          </svg>
        </button>
      </div>
      <button
        className={`w-full py-3 px-6 mb-6 rounded-lg text-left text-lg font-semibold ${activeTab === 'dashboard' ? 'bg-primaryColor text-white' : `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100'} hover:bg-primaryColor hover:text-white`}`}
        onClick={() => handleTabClick('dashboard', '/affiliate/dashboard')}>
        Dashboard
      </button>
      <button
        className={`w-full py-3 px-6 mb-6 rounded-lg text-left text-lg font-semibold ${activeTab === 'leads' ? 'bg-secondaryColor text-white' : `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100'} hover:bg-secondaryColor hover:text-white`}`}
        onClick={() => handleTabClick('leads', '/affiliate/leads?page=1&pageSize=100', '')}>
        Leads
      </button>
      <button
        className={`w-full py-3 px-6 mb-6 rounded-lg text-left text-lg font-semibold ${activeTab === 'subAffiliates' ? 'bg-primaryColor text-white' : `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100'} hover:bg-primaryColor hover:text-white`}`}
        onClick={() => handleTabClick('subAffiliates', '/affiliate/leads?page=1&pageSize=100&isSubAffiliates=1')}>
        Sub Affiliates
      </button>
      <button
        className={`w-full py-3 px-6 mb-6 rounded-lg text-left text-lg font-semibold ${activeTab === 'resources' ? 'bg-secondaryColor text-white' : `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100'} hover:bg-secondaryColor hover:text-white`}`}
        onClick={() => handleTabClick('resources', '/affiliate/resources')}>
        Resources
      </button>
      <button
        className={`w-full py-3 px-6 mb-6 rounded-lg text-left text-lg font-semibold ${activeTab === 'statistics' ? 'bg-primaryColor text-white' : `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100'} hover:bg-primaryColor hover:text-white`}`}
        onClick={() => handleTabClick('statistics', '/affiliate/statistics')}>
        Statistics
      </button>
      {company.companyId === '6243c824-9e29-46da-94c6-96d03d8cbb84' && (
        <button
          className={`w-full py-3 px-6 mb-6 rounded-lg text-left text-lg font-semibold ${activeTab === 'payments' ? 'bg-secondaryColor text-white' : `${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-100'} hover:bg-primaryColor hover:text-white`}`}
          onClick={() => handleTabClick('payments', '/affiliate/payments')}>
          Payments
        </button>
      )}
    </div>
  )
}
